import Modal from "bootstrap/js/dist/modal";

export default class ModalListMyProperty {
  constructor(element) {
    const modal = new Modal(element);
    const buttons = document.querySelectorAll(".j_list-my-property");

    if (buttons) {
      buttons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          modal.show();
        });
      });
    }
  }
}
